export const GET_ZELLE_USER = 'GIFTYA/GET_ZELLE_USER';
export const GET_ZELLE_USER_RESET = 'GIFTYA/GET_ZELLE_USER_RESET';
export const LOOKUP_ZELLE_USER = 'GIFTYA/LOOKUP_ZELLE_USER';
export const LOOKUP_ZELLE_USER_RESET = 'GIFTYA/LOOKUP_ZELLE_USER_RESET';
export const SUBMIT_ZELLE_REQUEST = 'GIFTYA/SUBMIT_ZELLE_REQUEST';
export const SUBMIT_ZELLE_REQUEST_RESET = 'GIFTYA/SUBMIT_ZELLE_REQUEST_RESET';

export const getZelleUser = (payload, meta = {}, error = false) => ({
    type: GET_ZELLE_USER,
    payload,
    meta,
    error
});
export const getZelleUserReset = (payload, meta, error) => ({
    type: GET_ZELLE_USER_RESET,
    payload,
    meta,
    error
});
export const lookupZelleUser = (payload, meta = {}, error = false) => ({
    type: LOOKUP_ZELLE_USER,
    payload,
    meta,
    error
});
export const lookupZelleUserReset = (payload, meta, error) => ({
    type: LOOKUP_ZELLE_USER_RESET,
    payload,
    meta,
    error
});
export const submitZelleRequest = (payload, meta = {}, error = false) => ({
    type: SUBMIT_ZELLE_REQUEST,
    payload,
    meta,
    error
});
export const submitZelleRequestReset = (payload, meta, error) => ({
    type: SUBMIT_ZELLE_REQUEST_RESET,
    payload,
    meta,
    error
});